import React from 'react';

import { quoteShape } from '../../prop-types';
import api from '../../REST/api';
import DeleteButton from '../../REST/DeleteButton';

function DeleteQuoteButton({ model }) {
  const name = model.number;
  const confirmationMessage = `Do you really want to delete ${name}?`;
  return (
    <DeleteButton
      onDelete={api.destroyQuote}
      id={model.id}
      name={name}
      confirmationMessage={confirmationMessage}
      className="float-right"
      redirectTo={`/opportunities/${model.opportunityId}/show`}
    />
  );
}

DeleteQuoteButton.propTypes = {
  model: quoteShape.isRequired,
};

export default DeleteQuoteButton;
